module.exports = __webpack_public_path__ + "static/photo-collage-5067394ee4285fc642bb5775c4bba7bb.png";